<script>
export default {
    data() {
        return {
            current: 0,
            timer: null
        }
    },
    props: {
        items: Array
    },
    methods: {

    },
    mounted() {
        const itemsCount = this.current.length;

        this.timer = setInterval(() => {
            if (this.current === (this.items.length - 1)) {
                this.current = 0;
            } else {
                this.current = this.current + 1;
            }
        }, 1500)
    },
    unmounted() {
        this.timer = null;
    }
}
</script>

<style>

</style>

<template>
    <ul>
        <li class='text-5xl text-primary font-bold md:text-[70px]' v-for="(item, key) in items" v-show="key === current">{{ item }}</li>
    </ul>
</template>
